module.exports = __webpack_public_path__ + "static/media/SB1.13e56871.png";